import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Supplier.css';

function SupplierSidebar({ closeSidebar }) {
  const [showReportSubMenu, setShowReportSubMenu] = useState(false);


  return (
    <div className="col-md-2 glass-sidebar min-vh-100 p-3">
      <h5 className="mb-4 text-secondary">Menu</h5>
      <ul className="nav flex-column">

        {/* Dashboard */}
        <li className="nav-item">
          <Link
            className="btn btn-outline-secondary w-100 text-start d-flex align-items-center gap-2 sidebar-item"
            to="/SupplierDashboard" onClick={closeSidebar}
          >
            <i className="bi bi-speedometer2"></i>
            Dashboard
          </Link>
        </li>

        {/* Products */}
        <li className="nav-item">
          <Link
            className="btn btn-outline-secondary w-100 text-start d-flex align-items-center gap-2 sidebar-item"
            to="/SupplierProducts" onClick={closeSidebar}
          >
            <i className="bi bi-box-seam"></i>
            Products
          </Link>
        </li>

        {/* Orders */}
        <li className="nav-item">
          <Link
            className="btn btn-outline-secondary w-100 text-start d-flex align-items-center gap-2 sidebar-item"
            to="/supplierOrders" onClick={closeSidebar}
          >
            <i className="bi bi-bag"></i>
            Orders
          </Link>
        </li>

        {/* Reports */}
        <li className="nav-item">
          <button
            className="btn btn-outline-secondary w-100 text-start d-flex align-items-center gap-2 sidebar-item"
            onClick={() => setShowReportSubMenu(!showReportSubMenu)}
          >
            <i className="bi bi-bar-chart-line"></i>
            Reports
            <i className={`bi ms-auto ${showReportSubMenu ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
          </button>

          {showReportSubMenu && (
            <ul className="nav flex-column ms-3 mt-2">
              <li className="nav-item">
                <Link to="/SupplierReports" onClick={closeSidebar} className="btn btn-outline-secondary btn-sm w-100 text-start d-flex align-items-center gap-2 sidebar-item">
                  <i className="bi bi-graph-up"></i>
                  Sales Report
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/productReports" onClick={closeSidebar} className="btn btn-outline-secondary btn-sm w-100 text-start d-flex align-items-center gap-2 sidebar-item">
                  <i className="bi bi-box"></i>
                  Product Report
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/SupplierReturns" onClick={closeSidebar} className="btn btn-outline-secondary btn-sm w-100 text-start d-flex align-items-center gap-2 sidebar-item">
                  <i className="bi bi-arrow-counterclockwise"></i>
                  Returns
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/CustomerReports" onClick={closeSidebar} className="btn btn-outline-secondary btn-sm w-100 text-start d-flex align-items-center gap-2 sidebar-item">
                  <i className="bi bi-people"></i>
                  Customer Report
                </Link>
              </li> */}
            </ul>
          )}
        </li>

        {/* Payments */}
        <li className="nav-item">
          <Link
            className="btn btn-outline-secondary w-100 text-start d-flex align-items-center gap-2 sidebar-item"
            to="/SupplierPayments" onClick={closeSidebar}
          >
            <i className="bi bi-wallet2"></i>
            Payments
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default SupplierSidebar;
